module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main page-border"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.billing")))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.showCurrentStat) ? _c('Current-stat', {
    attrs: {
      "team": _vm.team
    },
    on: {
      "loadChanged": _vm.currentStatLoadChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPaymentSection) ? _c('Payment-section', {
    attrs: {
      "team": _vm.team,
      "showBillingCredit": _vm.showBillingCredit,
      "showBillingInformation": _vm.showBillingInformation
    },
    on: {
      "loadChanged": _vm.paymentSectionLoadChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMonthlyUsageHistory) ? _c('Monthly-usage-history', {
    attrs: {
      "team": _vm.team
    },
    on: {
      "loadChanged": _vm.monthlyUsageHistoryLoadChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showStatement) ? _c('Statement', {
    attrs: {
      "team": _vm.team
    },
    on: {
      "loadChanged": _vm.statementLoadChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showClientUsageHistory) ? _c('Client-usage-history', {
    attrs: {
      "team": _vm.team,
      "showTitle": true
    },
    on: {
      "loadChanged": _vm.clientUsageHistoryLoadChanged
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e01d3d82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/BillingSummary.vue
// module id = 563
// module chunks = 1